export default __webpack_public_path__ + "static/media/Group 33.14bead38.svg";